import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';

import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faPhone, 
  faCalendarDays,
  faLocationPin,
  faLocationDot, 
  faPeopleGroup, 
  faSuitcaseRolling, 
  faCartFlatbedSuitcase 
} from '@fortawesome/free-solid-svg-icons';

import { 
    faFacebook, 
    faInstagram, 
    faLinkedin,
    faXTwitter
  } from '@fortawesome/free-brands-svg-icons';


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

const FooterSection = () => {
    return (
        <Box 
            sx={{
                width: '100%',
                backgroundColor: '#333333'
        }}>
            <Container>
                <Grid 
                    container 
                    spacing={2} 
                    sx={{
                        width: "100%",
                        height: 'auto',
                        backgroundColor: '#333333',
                        paddingBottom: "20px"
                    }}
                >
                    <Grid size={12}>
                        <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
                            <img src='./companynamelogowhite.png' alt='Logo'></img>
                        </Container>
                    </Grid>
                    <Grid size={{xs: 12, sm: 12, md: 4}} sx={{marginTop: "40px"}}>
                        <Container sx={{ display: 'flex', alignItems: 'center', textAlign: {xs: 'center', sm: 'center', md: 'left'} }}>
                            <Stack spacing={2} sx={{backgroundColor:'#333333', width: '100%'}}>
                                <Typography sx={{color: '#ffffff', fontSize: '20px', fontWeight: 600}}>
                                    Our company
                                </Typography>
                                <Typography sx={{color: '#ffffff', fontSize: '16px', fontWeight: 400}}>
                                    We are an electronic product development company.
                                </Typography>
                                <Typography sx={{color: '#ffffff', fontSize: '16px', fontWeight: 400}}>
                                    Registered in England and Wales number 15902350.
                                </Typography>
                            </Stack>
                        </Container>
                    </Grid>
                    <Grid size={{xs: 12, sm: 12, md: 4}} sx={{marginTop: "40px"}}>
                    <Container sx={{ display: 'flex', alignItems: 'center', textAlign: {xs: 'center', sm: 'center', md: 'left'} }}>
                            <Stack spacing={2} sx={{backgroundColor:'#333333', width: '100%'}}>
                                <Typography sx={{color: '#ffffff', fontSize: '20px', fontWeight: 600}}>
                                    We're experts in
                                </Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>IoT Monitoring</Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>Temperature Control Systems</Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>Compliance Management</Typography>
                            </Stack>
                        </Container>
                    </Grid>
                    <Grid size={{xs: 12, sm: 12, md: 4}} sx={{marginTop: "40px"}}>
                    <Container sx={{ display: 'flex', alignItems: 'center', textAlign: {xs: 'center', sm: 'center', md: 'left'} }}>
                            <Stack spacing={2} sx={{backgroundColor:'#333333', width: '100%'}}>
                                <Typography sx={{color: '#ffffff', fontSize: '20px', fontWeight: 600}}>
                                    Capabilities we provide
                                </Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>Real-Time Data Analytics</Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>Cloud Integration</Typography>
                                <Typography variant="body2" sx={{color: '#ffffff', fontSize: '16px', fontWeight: 'thin'}}>Temperature Sensing Technology</Typography>
                            </Stack>
                        </Container>
                    </Grid>
                    <Grid size={12}>
                        <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', alignItems: "center", width: "100%" }}>
                            <Box sx={{ alignItems: 'center'}}>
                                <FontAwesomeIcon icon={faFacebook} style={{ fontSize: 24, color: '#ffffff', padding: 10 }} />
                                <FontAwesomeIcon icon={faInstagram} style={{ fontSize: 24, color: '#ffffff', padding: 10 }} />
                                <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: 24, color: '#ffffff', padding: 10}} />
                                <FontAwesomeIcon icon={faXTwitter} style={{ fontSize: 24, color: '#ffffff', padding: 10 }} />
                            </Box>
                        </Container>
                    </Grid>

{/* 
            <Stack spacing={2} sx={{backgroundColor:'#000000', width: '300px'}}>
                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <img src='./companynamelogowhite.png' alt='Logo'></img>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '24px', fontWeight: 'bold'}}>
                        Our Company
                    </Typography>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '18px'}}>
                        We are an electronic product development company.
                    </Typography>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '18px'}}>
                        Registered in England and Wales number 15902350.
                    </Typography>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <FontAwesomeIcon icon={faFacebook} style={{ fontSize: 24, color: '#ffffff' }} />
                    <FontAwesomeIcon icon={faInstagram} style={{ fontSize: 24, color: '#ffffff' }} />
                    <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: 24, color: '#ffffff' }} />
                    <FontAwesomeIcon icon={faXTwitter} style={{ fontSize: 24, color: '#ffffff' }} />
                </Container>
            </Stack>

            <Stack spacing={2} sx={{backgroundColor:'#000000', width: '300px'}}>
                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '14px'}}>
                        Terms of Service
                    </Typography>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '14px'}}>
                        Privacy Statement
                    </Typography>
                </Container>

                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '14px'}}>
                        Platform & Client Data Security
                    </Typography>
                </Container>
            </Stack>

            <Stack spacing={2} sx={{backgroundColor:'#000000', width: '300px'}}>
                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography sx={{color: '#ffffff', fontSize: '14px'}}>
                        Terms of Service
                    </Typography>
                </Container>
            </Stack>
*/}
                </Grid>
            </Container>
        </Box>
    );
};

export default FooterSection;